import { Pages, Rutas } from '@/constants/rutas';

export const SeoUrls = {
    [Pages.ESTADISTICAS_FANTASY_JUGADORES]: Rutas.ESTADISTICAS_FANTASY_JUGADORES,
    [Pages.MERCADO]: Rutas.MERCADO,
    [Pages.MERCADO_EQUIPOS]: Rutas.MERCADO_EQUIPOS,
    [Pages.NOTICIAS]: Rutas.NOTICIAS,
    [Pages.INICIO]: Rutas.INICIO,
    [Pages.ANALIZA_TU_PLANTILLA]: Rutas.ANALIZA_TU_PLANTILLA,
    [Pages.COMPARADOR_DE_JUGADORES]: Rutas.COMPARADOR_DE_JUGADORES,
    [Pages.LESIONADOS_SANCIONADOS_APERCIBIDOS]: Rutas.LESIONADOS_SANCIONADOS_APERCIBIDOS,
    [Pages.CLASIFICACION]: Rutas.CLASIFICACION,
    [Pages.MEJORES_RACHAS]: Rutas.MEJORES_RACHAS,
    [Pages.INICIA_SESION]: Rutas.INICIA_SESION,
    [Pages.REGISTRATE]: Rutas.REGISTRATE,
    [Pages.MIS_PLANTILLAS]: Rutas.MIS_PLANTILLAS,
    [Pages.EDITAR_PLANTILLA]: Rutas.EDITAR_PLANTILLA,
    [Pages.CREAR_PLANTILLA]: Rutas.CREAR_PLANTILLA,
    [Pages.TERMINOS_CONDICIONES]: Rutas.TERMINOS_CONDICIONES,
    [Pages.POLITICAS_PRIVACIDAD]: Rutas.POLITICAS_PRIVACIDAD,
    [Pages.CONTACTANOS]: Rutas.CONTACTANOS,
    [Pages.PARTIDO]: Rutas.PARTIDO,
    [Pages.CALENDARIO_FANTASY]: Rutas.CALENDARIO_FANTASY,
    [Pages.REESTABLECER_CONTRASENA]: Rutas.REESTABLECER_CONTRASENA,
    [Pages.ANALISIS_PLANTILLA]: Rutas.ANALIZA_TU_PLANTILLA,
    [Pages.ENCUESTA_DE_SATISFACCION]: Rutas.ENCUESTA_DE_SATISFACCION,
    [Pages.PERFIL_DE_USUARIO]: Rutas.PERFIL_DE_USUARIO,
    [Pages.OLVIDASTE_TU_CONTRASENA]: Rutas.OLVIDASTE_TU_CONTRASENA,
    [Pages.FANTASY_MANAGER]: Rutas.FANTASY_MANAGER,
    [Pages.PREDICTING_MANAGER]: Rutas.PREDICTING_MANAGER,
    [Pages.PREDICTING_MANAGER_RANKING]: Rutas.PREDICTING_MANAGER_RANKING,
    [Pages.ADMINISTRADOR_JUGADORES]: Rutas.ADMINISTRADOR_JUGADORES,
    [Pages.PREDICTING_MANAGER_ALINEACIONES]: Rutas.PREDICTING_MANAGER_ALINEACIONES,
    [Pages.PREDICTING_MANAGER_RULES]: Rutas.PREDICTING_MANAGER_RULES,
    [Pages.COLABORADORES]: Rutas.COLABORADORES,
    [Pages.COLABORADORES_NOTICIAS]: Rutas.COLABORADORES_NOTICIAS,
    [Pages.JUGADORES]: Rutas.JUGADORES,
    [Pages.QUINIELA_JUEGO]: Rutas.QUINIELA_JUEGO,
    [Pages.PUJA_FANTASY]: Rutas.PUJA_FANTASY,
    [Pages.PUJA_FANTASY_BIWENGER]: Rutas.PUJA_FANTASY_BIWENGER,
    [Pages.QUINIELA_CLASIFICACION]: Rutas.QUINIELA_CLASIFICACION,
    [Pages.QUINIELA_REGLAS_DEL_JUEGO]: Rutas.QUINIELA_REGLAS_DEL_JUEGO,
    [Pages.JUGADORES_LESIONADOS]: Rutas.JUGADORES_LESIONADOS,
    [Pages.JUGADORES_SANCIONADOS]: Rutas.JUGADORES_SANCIONADOS,
    [Pages.JUGADORES_DUDAS]: Rutas.JUGADORES_DUDAS,
    [Pages.JUGADORES_APERCIBIDOS]: Rutas.JUGADORES_APERCIBIDOS,
    [Pages.NOTICIAS_FLASH]: Rutas.NOTICIAS_FLASH,
    [Pages.CALENDARIO_COMPETICIONES]: Rutas.CALENDARIO_COMPETICIONES,
    [Pages.CONVOCATORIAS]: Rutas.CONVOCATORIAS,
    [Pages.VIRUS_FIFA]: Rutas.VIRUS_FIFA,
    [Pages.APUESTAS_DEPORTIVAS]: Rutas.APUESTAS_DEPORTIVAS,
    [Pages.MERCADO_FICHAJES]: Rutas.MERCADO_FICHAJES,
    [Pages.MERCADO_BIWENGER]: Rutas.MERCADO_BIWENGER,
    [Pages.ESTADISTICAS_BIWENGER]: Rutas.ESTADISTICAS_BIWENGER,
    [Pages.LIDERES_ESTADISTICAS]: Rutas.LIDERES_ESTADISTICAS,
    [Pages.INSTALL_APP]: Rutas.INSTALL_APP,
    [Pages.PREMIOS_Y_SORTEOS]: Rutas.PREMIOS_Y_SORTEOS,
    [Pages.ACTIVIDADES]: Rutas.ACTIVIDADES,
    [Pages.SALON_DE_LA_FAMA]: Rutas.SALON_DE_LA_FAMA,
    [Pages.CHOLLOS_FANTASY_BIWENGER]: Rutas.CHOLLOS_FANTASY_BIWENGER,
    [Pages.CHOLLOS_FANTASY_RELEVO]: Rutas.CHOLLOS_FANTASY_RELEVO,
    [Pages.QUEDADA_FANTASY]: Rutas.QUEDADA_FANTASY,
    [Pages.LANZADORES_PENALTIS]: Rutas.LANZADORES_PENALTIS,
    [Pages.TIER_LIST]: Rutas.TIER_LIST,
    [Pages.TIER_LIST_PUBLIC]: Rutas.TIER_LIST_PUBLIC,
    [Pages.NUEVA_TIER_LIST]: Rutas.NUEVA_TIER_LIST,
    [Pages.EDIT_TIER_LIST]: Rutas.EDIT_TIER_LIST,
    [Pages.VISUALIZAR_TIER_LIST]: Rutas.VISUALIZAR_TIER_LIST,
    [Pages.EDIT_TIER_LIST]: Rutas.EDIT_TIER_LIST,
    [Pages.FANTASY_DAZN_FALLECIO]: Rutas.FANTASY_DAZN_FALLECIO,
    [Pages.KIT_DIGITAL]: Rutas.KIT_DIGITAL,
    [Pages.ORACULO_FANTASY]: Rutas.ORACULO_FANTASY,
    [Pages.SITIOS_RECOMENDADOS]: Rutas.SITIOS_RECOMENDADOS,
    [Pages.CREADORES_CONTENIDO]: Rutas.CREADORES_CONTENIDO,
    [Pages.PUNTUACIONES_FANTASY]: Rutas.PUNTUACIONES_FANTASY,
    [Pages.PREPARADOR_JORNADA]: Rutas.PREPARADOR_JORNADA,
    [Pages.ALINEACIONES_PROBABLES]: Rutas.ALINEACIONES_PROBABLES,
    [Pages.NOVEDADES]: Rutas.NOVEDADES,
    [Pages.PREMIUM]: Rutas.PREMIUM,
    [Pages.PREMIUM_ACTIVIDADES]: Rutas.PREMIUM_ACTIVIDADES,
    [Pages.ANALISIS_POST_PARTIDO]: Rutas.ANALISIS_POST_PARTIDO,
    [Pages.SALDO_ARBITRAL_PARTIDOS]: Rutas.SALDO_ARBITRAL_PARTIDOS,
    [Pages.SALDO_ARBITRAL_PARTIDOS_ROJAS]: Rutas.SALDO_ARBITRAL_PARTIDOS_ROJAS,
    [Pages.CENTRO_INFORMACION]: Rutas.CENTRO_INFORMACION,
    [Pages.BUSCADOR_DE_JUGADORES]: Rutas.BUSCADOR_DE_JUGADORES,
    [Pages.GUIAS_FANTASY]: Rutas.GUIAS_FANTASY,
    [Pages.GUIAS_FANTASY_FANTASY_BIWENGER]: Rutas.GUIAS_FANTASY_FANTASY_BIWENGER,
    [Pages.GUIAS_FANTASY_FANTASY_MARCA]: Rutas.GUIAS_FANTASY_FANTASY_MARCA,
    [Pages.GUIAS_FANTASY_FANTASY_LA_LIGA]: Rutas.GUIAS_FANTASY_FANTASY_LA_LIGA,
    [Pages.GUIAS_FANTASY_FANTASY_MISTER]: Rutas.GUIAS_FANTASY_FANTASY_MISTER,
    [Pages.MERCADO_DAZN]: Rutas.MERCADO_DAZN,
    [Pages.CHOLLOS_FANTASY_MARCA]: Rutas.CHOLLOS_FANTASY_MARCA,
    [Pages.FANTASY_MARCA_MERCADO]: Rutas.FANTASY_MARCA_MERCADO,
    [Pages.FANTASY_MARCA_MERCADO_EQUIPOS]: Rutas.FANTASY_MARCA_MERCADO_EQUIPOS,
    [Pages.FANTASY_MARCA_SUBIDAS_Y_BAJADAS]: Rutas.FANTASY_MARCA_SUBIDAS_Y_BAJADAS,
    [Pages.PREDICCION_DE_MERCADO]: Rutas.PREDICCION_DE_MERCADO,
    [Pages.CHOLLOS_FANTASY_MISTER]: Rutas.CHOLLOS_FANTASY_MISTER,
    [Pages.MISTER_FANTASY_MERCADO]: Rutas.MISTER_FANTASY_MERCADO,
    [Pages.RULETA_FANTASY]: Rutas.RULETA_FANTASY,
    [Pages.RULETA_FANTASY_RANKING]: Rutas.RULETA_FANTASY_RANKING,
    [Pages.RULETA_FANTASY_RANKING_GLOBAL]: Rutas.RULETA_FANTASY_RANKING_GLOBAL,
};
